/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-danger */
/* eslint-disable key-spacing */
/* eslint-disable semi */
/* eslint-disable no-console */
/* eslint-disable arrow-parens */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import React from 'react'
import { Alert } from 'react-bootstrap'
import * as H from 'history'
import queryString from 'query-string'
import { LoginController } from '../controllers/LoginController'
import { ISupportSpinner } from '../shared/Ajax'
import CoatOfArmsLogo from '../images/coat-of-arms'

export interface LoginPageProps {
  location: H.Location
}

export interface LoginPageState {
    loginInProgress: boolean
    topTextHtml: string,
    rightTextHtml: string,
    bottomTextHtml: string,
}

export class LoginPage extends React.Component<LoginPageProps, LoginPageState> implements ISupportSpinner {
  ajax: LoginController

  constructor(props: LoginPageProps) {
    super(props)

    this.ajax = new LoginController()

    this.state = {
       loginInProgress: false,
        topTextHtml: '',
        rightTextHtml: '',
        bottomTextHtml: '',
    }
  }

  componentDidMount() {
    // WARNING: there is something peculiar about this Ajax library, calls have to be nested or some will fail SILENTLY!
    /*  this.ajax.getLatestLodgementPeriods(this, LodgementPeriodType.Lodgement, (d) => {
          console.log('lodgementPeriods:', d)
      this.setState({ lodgementPeriods: d })

      this.ajax.getAnnouncementString(this,
          (str) => {
          console.log('Announcement:', str )
          this.setState({ announcement: str })

              this.ajax.getAboutEmdgDescriptionString(this, (s) => {
                  console.log('aboutEmdgDescription:', s)
            this.setState({
              aboutEmdgDescription: s,
            })
          })
        })
    }) */

    fetch('/api/Login/GetLoginPageText', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
        this.setState({
            topTextHtml   : data.LOGIN_PAGE_TopText,
            rightTextHtml : data.LOGIN_PAGE_RightText,
            bottomTextHtml: data.LOGIN_PAGE_BottomText,
        })
    })
    .catch((error) => {
        console.error('Error:', error);
    });
  }

  login = (e: React.MouseEvent) => {
    e.preventDefault()

    this.ajax.login(this, (d) => {
      const returnUrl = queryString.parse(this.props.location.search).returnUrl || '/'

      if (d) {
        const loginUrl = `${d}?returnurl=${returnUrl}`
        window.location.assign(loginUrl)
      } else {
        window.location.assign(returnUrl)
      }
    })
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  toggleSpinner(on: boolean, callback: { (): any }) {
    this.setState({ loginInProgress: on }, callback)
  }

  render() {

    return (
      <div className="container-fluid pt-3">

        {this.state.topTextHtml && (

          <Alert className="emdg-page-alerts">
            <div dangerouslySetInnerHTML={{ __html: this.state.topTextHtml }} />
          </Alert>
        )}

        <div className="emdg-callout">
          {/*
           <div className="row mx-0">
            <h2>Login</h2>
           </div>
          */}

          <div className="row mt-2">

            <div className="col-sm-6">
              <h2>Login</h2>
              <p className="mb-3">
                Use your Digital ID (myID) to get started.
              </p>
              <span>
                <div className="digitalidentitycontainer">
                  <div className="digitalidentitybutton">
                    <a href="#" onClick={this.login}>
                      <CoatOfArmsLogo />
                      Continue with Digital ID
                    </a>
                  </div>
                  <div className="digitalidentitycontent">
                    <p>
                       <a href="https://www.digitalidsystem.gov.au/" target="_blank" rel="noreferrer">Digital ID</a>
                      {' '}
                      is a safe, secure and convenient way to prove and reuse your identity online.
                    </p>
                  </div>
                </div>
              </span>
            </div>

            <div className="col-sm-6">
                <div dangerouslySetInnerHTML={{ __html: this.state.rightTextHtml }} />
            </div>
          </div>
        </div>

        {this.state.bottomTextHtml
          && (
            <div className="row">
                <div dangerouslySetInnerHTML={{ __html: this.state.bottomTextHtml }} />
            </div>
          )}

      </div>
    )
  }
}
